// 3rd party imports
import * as React from 'react';
import { inject } from 'mobx-react';

// bernie
import { ContextStore } from 'bernie-core';

// stores
import { LinkStore } from 'stores';

// ui
import { UitkSpacing } from 'uitk-react-spacing';

// components
import { DeeplinkBuilderComponent } from './common';

interface Props {
  link?: LinkStore;
  context?: ContextStore;
}

@inject('link', 'context')
export class DeeplinkBuilder extends React.Component<Props> {
  public render() {
    return (
      <UitkSpacing className="container" padding={{ block: 'twelve' }}>
        <main>
          <DeeplinkBuilderComponent />
        </main>
      </UitkSpacing>
    );
  }
}
